import {
    ProductExDetailBeforeOrderListElementType,
    ProductExDetailBeforeOrderListSearchParamType,
    ProductExDetailBeforeOrderListType,
    ProductExDetailType
} from "../interface";
import {useParams} from "react-router-dom";
import React, {Dispatch, SetStateAction, useState} from "react";
import {
    productExDetailBeforeOrderListElementInit,
    productExDetailBeforeOrderListInit,
    productExDetailBeforeOrderListSearchParamInit
} from "../state";
import {useReadBeforeOrderListEx} from "../hooks/useReadBeforeOrderListEx";
import {useUser} from "../../../../../util/userContext/UserContext";
import EmptyTableRow from "../../../../common/EmptyTableRow";
import PaginationSub from "../../../../../components/common/pagination/PaginationSub";
import {UseFormSetValue} from "react-hook-form";
import {useModal} from "../../../../../hooks";
import AuthorityChecker from "../../../../../components/common/authorityGuard/AuthorityChecker";

interface PropsType {
    setValue: UseFormSetValue<ProductExDetailType>
    setAppliedNewPShipment: Dispatch<SetStateAction<number>>
}

export default function Section4({setValue, setAppliedNewPShipment}: PropsType) {
    const {id} = useParams()
    const {user} = useUser();
    const {handleModal} = useModal();

    const [searchParam, setSearchParam] = useState<ProductExDetailBeforeOrderListSearchParamType>(productExDetailBeforeOrderListSearchParamInit)
    const [selectItem, setSelectItem] = useState<{
        pageNo: number,
        idx: number,
        data: ProductExDetailBeforeOrderListElementType
    }>({pageNo: 0, idx: 0, data: productExDetailBeforeOrderListElementInit})

    const {data: beforeOrderListResult} = useReadBeforeOrderListEx({
        param: {
            ...searchParam,
            newErpProductid: id ?? "",
            userId: user?.userId ?? 0
        }
    })
    const beforeOrder: ProductExDetailBeforeOrderListType = beforeOrderListResult ?? productExDetailBeforeOrderListInit

    const clickRadio = (el: ProductExDetailBeforeOrderListElementType, idx: number) => {
        setSelectItem({pageNo: searchParam.pageNo, idx: idx, data: el})
    }

    const btnApply = () => {
        if (selectItem.data.newLErpProductValue === "") {
            handleModal({
                isOpen: true,
                contents: "이전 결제 내역을 선택해주세요.",
                type: "alert"
            })
        } else {
            const item = selectItem.data

            setValue("searchProductWithAccountDetailRes.dailyAverageRate", item.exchangeRateCondition1Name)
            setValue("searchProductWithAccountDetailRes.initialQuotedRate", item.exchangeRateCondition2Name)
            setValue("searchProductWithAccountDetailRes.remittanceRate", item.exchangeRateCondition3Name)
            setValue("productDetail.newIQty", item.newIQty)
            setAppliedNewPShipment(item.newPShipment)
        }
    }

    return <>
        <div className="table_top">
            <h6 className="table_stats">이전 결제 내역(<span>{beforeOrder.totalCount ?? 0}</span>건)</h6>
            <div className="table_toolbar">
                <AuthorityChecker authorityNames={['orderWriteYn']}>
                    <button className="btn btn-info w-100px h-38px" onClick={btnApply}>적용하기</button>
                </AuthorityChecker>
            </div>
        </div>
        <div className="table_scroll">
            <table className="table table-bordered my_table">
                <thead>
                <tr>
                    <th style={{width: "4.4%"}}></th>
                    <th style={{width: "8.8%"}}>구매 일자</th>
                    <th style={{width: "22%"}}>제품</th>
                    <th style={{width: "11.94%"}}>규격</th>
                    <th style={{width: "8.8%"}}>수량</th>
                    <th style={{width: "26.4%"}} colSpan={3}>환율</th>
                    <th style={{width: "8.8%"}}>배송방법</th>
                    <th>상태</th>
                </tr>
                </thead>
                <tbody>
                {beforeOrder.list.length !== 0 ?
                    beforeOrder.list.map((el, idx) => <tr
                        className={`clickable ${selectItem.pageNo === searchParam.pageNo && selectItem.idx === idx ? "lightblue" : ""}`}
                        onClick={() => clickRadio(el, idx)}>
                        <td>
                            <div className="checkbox_outer">
                                <input
                                    className="form-check-input"
                                    type="radio"
                                    checked={selectItem.pageNo === searchParam.pageNo && selectItem.idx === idx}
                                />
                            </div>
                        </td>
                        <td className="text-center">{el.purchaseOrderDt}</td>
                        <td>{el.newTxtNmItem}</td>
                        <td className="text-center">{el.newTxtStandard}</td>
                        <td className="text-center">{el.newIQty}</td>
                        <td style={{width: "8.8%"}} className="text-center">{el.exchangeRateCondition1Name}</td>
                        <td style={{width: "8.8%"}} className="text-center">{el.exchangeRateCondition2Name}</td>
                        <td className="text-center">{el.exchangeRateCondition3Name}</td>
                        <td className="text-center">{el.shipmentName}</td>
                        <td className="text-center">{el.orderState}</td>
                    </tr>)
                    : <EmptyTableRow colSpan={10}/>
                }
                </tbody>
            </table>
        </div>

        <PaginationSub totalCount={beforeOrder.totalCount ?? 0}
                       currentPage={searchParam.pageNo}
                       onChangeCallback={(i) => setSearchParam({...searchParam, pageNo: i})}/>
    </>
}